import angular from 'angular'
import swiper from 'angular-ui-swiper'

import 'normalize.css'
import 'flexboxgrid/css/flexboxgrid.min.css'
import 'angular-ui-swiper/dist/angular-ui-swiper.css'

import uiRouter from 'angular-ui-router'
import Common from './common/common'
import Components from './components/components'
import AppComponent from './app.component'
import texts from './app.texts'

angular.module('app', [
        uiRouter,
        Common,
        Components,
        swiper
    ])
    .config(($locationProvider, $httpProvider) => {
        'ngInject'

        // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
        $locationProvider.html5Mode(true).hashPrefix('!')

        $httpProvider.interceptors.push(function ($q) {
            return {
                'request': function (config) {
                    try {
                        const Token = localStorage.getItem('tourists_token')

                        config.headers.authorization = `Bearer ${Token}`
                    } catch (e) {
                        config.headers.authorization = null
                    }

                    return config
                },
                'response': function (response) {
                    if (response.headers('authorization-expired') === 'expired') {
                        localStorage.removeItem('tourists_user')
                        localStorage.removeItem('tourists_token')
                    }

                    return response
                }
            }
        })
    })
    .constant('config', {
        baseUrl: 'http://localhost:5000',
        frontUrl: 'https://www.emotionsaregeorgia.com'
    })

    .run(['$rootScope', '$state', '$window', '$location', function ($rootScope, $state, $window, $location) {

        $rootScope.$on('$locationChangeStart', function (event, next, current) {
            if ($location.path() === '/' && ($window.innerWidth <= 767 || localStorage.getItem('tourists_welcome'))) {
                event.preventDefault()

                $state.go('home')
            }

            setTimeout(() => {
                const currentState = $state.current.name
                const language = localStorage.getItem('tourists_lang') || 'EN'

                if (texts['EN'][currentState]) {
                    $('title').html(texts['EN'][currentState])
                } else {
                    $('title').html('Emotions Are Georgia')
                }
            }, 0)

        })
    }])

    .component('app', AppComponent)



// WEBPACK FOOTER //
// ./client/app/app.js